import React from "react";
import { API_FLOW } from "../data/content";
import Icon from "./Icon";

function ApiFlowDiagram() {
  return (
    <div className="how-api">
      <span className="mono-tag how-api-tag">API communication</span>
      <h3 className="how-api-title">Every action follows the same request path</h3>
      <div className="how-api-flow">
        {API_FLOW.map((step, index) => (
          <React.Fragment key={step}>
            <div className="how-api-node">{step}</div>
            {index !== API_FLOW.length - 1 && (
              <Icon name="arrow" size={18} className="how-api-arrow" />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}

export default ApiFlowDiagram;
